/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

import api from './api';
import type {
  SharedExpression,
  CreateSharedExpressionInput,
  UpdateSharedExpressionInput,
} from '../types/expression-library';

export const expressionLibraryService = {
  async listExpressions(): Promise<SharedExpression[]> {
    const { data } = await api.get<SharedExpression[]>('/api/expressions');
    return data ?? [];
  },

  async createExpression(input: CreateSharedExpressionInput): Promise<SharedExpression> {
    const { data } = await api.post<SharedExpression>('/api/expressions', input);
    return data;
  },

  async updateExpression(id: string, input: UpdateSharedExpressionInput): Promise<SharedExpression> {
    const { data } = await api.put<SharedExpression>(`/api/expressions/${id}`, input);
    return data;
  },

  async deleteExpression(id: string): Promise<void> {
    await api.delete(`/api/expressions/${id}`);
  },

  async toggleExpression(id: string, enabled: boolean): Promise<SharedExpression> {
    const { data } = await api.put<SharedExpression>(`/api/expressions/${id}`, {
      enabled,
    });
    return data;
  },
};
